export default function SectionTitle({ eyebrow, title, desc, icon: Icon }) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-2">
        {Icon && (
          <div className="w-8 h-8 rounded-lg bg-[var(--accent)]/12 border border-[var(--accent)]/25 flex items-center justify-center">
            <Icon size={16} className="text-accent" />
          </div>
        )}
        {eyebrow && (
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-accent font-mono-data">{eyebrow}</span>
        )}
      </div>
      <h2 className="font-heading text-2xl lg:text-3xl font-bold tracking-tight">{title}</h2>
      {desc && <p className="text-[var(--text-secondary)] text-sm mt-1.5 max-w-2xl">{desc}</p>}
    </div>
  );
}
